import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { staggerParent, staggerChild } from "@/components/Motion";
import { Star, Sparkles, CalendarPlus, ArrowRight } from "lucide-react";

const EXTRAS = [
  { key: "extra_feature", icon: Star, t: "Feature listing", price: "£4.99", unit: "per car, per week", d: "Your car is pinned to the top of search results with a Featured badge." },
  { key: "extra_recommend", icon: Sparkles, t: "Home page recommendations", price: "£9.99", unit: "per car, 7 days", d: "Shown on the home page to buyers whose browsing matches your car. Best for your strongest stock." },
  { key: "extra_extend", icon: CalendarPlus, t: "Promotion: 1-week extension", price: "£4.99", unit: "per car", d: "Keeps a car with an end date live for 7 more days." },
];

export function Extras({ audience = "private" }) {
  return (
    <section className="mt-24" data-testid="extras-section">
      <span className="text-xs uppercase tracking-widest font-semibold text-teal">Paid extras</span>
      <h2 className="font-heading font-extrabold text-navy tracking-tighter text-3xl sm:text-4xl mt-2">Sell faster with a boost.</h2>
      <p className="text-slatev mt-3 max-w-xl">Add extras to any live car from My garage. Available to {audience === "dealer" ? "dealerships and private sellers" : "private sellers and dealerships"}.</p>
      <motion.div variants={staggerParent} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-60px" }} className="grid md:grid-cols-3 gap-5 mt-10">
        {EXTRAS.map((e) => (
          <motion.div key={e.key} variants={staggerChild} whileHover={{ y: -6 }} data-testid={`extra-${e.key}`}
            className="bg-white rounded-3xl border border-navy/10 p-7 transition-shadow hover:shadow-[0_24px_50px_-24px_rgba(22,36,47,0.4)]">
            <div className="w-11 h-11 rounded-xl bg-teal-tint flex items-center justify-center"><e.icon className="w-5 h-5 text-teal" /></div>
            <h3 className="font-heading font-bold text-xl text-navy mt-5">{e.t}</h3>
            <div className="mt-2 flex items-baseline gap-1.5"><span className="font-heading font-extrabold text-3xl text-navy tracking-tight">{e.price}</span><span className="text-sm text-slatev">{e.unit}</span></div>
            <p className="text-sm text-slatev mt-3">{e.d}</p>
          </motion.div>
        ))}
      </motion.div>
      <Link to="/dashboard" data-testid="extras-garage-link" className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-teal hover:text-teal-dark">Boost a car in My garage <ArrowRight className="w-4 h-4" /></Link>
    </section>
  );
}
